// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
	return {
		MuiTypography: {
			styleOverrides: {
				gutterBottom: {
					marginbottom: 12
				}
			}
		}
	};
}
